
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.977 14.428L13 8.428l-10.977 6c-.458.25-.652.878-.433 1.402.154.367.478.599.833.598H23.58c.507.002.92-.468.922-1.048 0-.406-.202-.778-.522-.952h-.004zm-13.477-10c0-1.579 1.12-2.858 2.501-2.856 1.381 0 2.5 1.28 2.5 2.858 0 1.22-.68 2.306-1.69 2.702-.485.19-.81.71-.81 1.296","stroke":"currentColor","stroke-width":"1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    